import React from 'react';
import deleteIcon from "../../../assets/icons/delete.svg";

interface DeleteButtonProps {
    onDelete: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void; // Define the type of the `onDelete` function
}

const DeleteButton: React.FC<DeleteButtonProps> = ({ onDelete }) => {
    return (
        <div className="icon-button" onClick={(e) => onDelete(e)}>
            <img
                id="popup"
                src={deleteIcon}
                alt="Delete Button"
                className="icon"               
            />
        </div>
    );
}

export default DeleteButton;